import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"

import H6 from "../atoms/H6"
import Image from "../atoms/Image"
import TextCentered from "../helpers/TextCentered"
import Grid from "../organisms/Grid"
import Header from "../organisms/Header"

import "reset-css"
import "./Variables.css"
import "./Index.css"
import styles from "./Layout.module.css"

const Layout = ({ children, scrollLocked }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      footerImage: file(relativePath: { eq: "IMG_0903-small.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 125, maxHeight: 125, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <Helmet>
        <html className={scrollLocked && styles.lockScroll} />
        <link
          href="https://fonts.googleapis.com/css?family=Playfair+Display:900|Oswald:200,300,500&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <Header siteTitle={data.site.siteMetadata.title} />
        </div>
        <main className={styles.body}>{children}</main>
        <footer className={styles.footer}>
          <Grid type="rows">
            <TextCentered>
              <H6>We can’t wait to celebrate with you.</H6>
            </TextCentered>
            <div>
              <div className={styles.footerImage}>
                <Image fluid={data.footerImage.childImageSharp.fluid} />
              </div>
            </div>
          </Grid>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  scrollLocked: PropTypes.bool,
}

Layout.defaultProps = {
  scrollLocked: false,
}

export default Layout
